<template>
  <div>
    <!-- ナビバー -->
    <template v-if="appBarTransparent">
      <v-app-bar fixed flat color="transparent" height="100vh">
        <v-toolbar-title>
          <v-img :src="tileimgsrc" title="パターン1" max-width="200px"></v-img>
        </v-toolbar-title>
        <v-spacer />
        <v-btn large rounded color="indigo darken-1" dark min-width="120px" elevation="10" @click="regsterNew()" >
          会員登録(無料)
        </v-btn>
        <v-btn large rounded color="blue darken-3" dark min-width="120px" elevation="10" @click="login()" class="ml-6">
          ログイン
        </v-btn>
      </v-app-bar>
    </template>
    <template v-else>
      <v-app-bar fixed flat color="white" height="100vh" style="opacity:0.9">
        <v-toolbar-title>
          <v-img :src="tileimgsrc" title="パターン1" max-width="200px"></v-img>
        </v-toolbar-title>
        <v-spacer />
        <v-btn large rounded outlined color="indigo darken-4" dark min-width="120px" elevation="10" @click="regsterNew()" >
          会員登録(無料)
        </v-btn>
        <v-btn large rounded outlined color="blue darken-4" dark min-width="120px" elevation="10" @click="login()" class="ml-6">
          ログイン
        </v-btn>
      </v-app-bar>
    </template>

    <!-- メイン -->
    <v-main>

      <!-- トップイメージ -->
      <v-parallax src="@/assets/img/4506344_m.jpg" height="1120" >
      
        <v-row align-content="center" justify="center" style="color: black; height: 28%;">
          <v-col class="text-center " cols="12">
            <h4 class="subheading">と う き た く す</h4>
            <!-- <h4 class="subheading">{{ $t("IMB001") }}</h4> -->
            <p class="font-family-rogo text-kanji-logo">登記託</p>
          </v-col>
        </v-row>
        <v-row align-content="center" justify="center" style="color: #1A237E;" class="mb-0">
          <v-col cols="12" sm="10" md="10" lg="10" xl="10" class="d-flex align-center justify-center text-left font-family-comment text-subtitle-1 text-sm-h5 text-lg-h4 text-xl-h4">
            <transition name="fade">
              <div v-show="cardViewFlg">
                <p class="d-flex align-center justify-center">Webからカンタン申込み</p>
                <p class="d-flex align-center justify-center">役員変更の登記申請は「<span class="font-family-rogo" style="font-size: 1.4em;">登記託</span>」におまかせ</p>
                <p class="d-flex align-center justify-center">司法書士による安心対応</p>
                <br/>
                <p class="d-flex align-center justify-center subtitleEn font-weight-light">Good quality stable legal service</p>
              </div>
            </transition>
          </v-col>
        </v-row>
        <v-row class="my-0 py-0">
          <v-col cols="12" class="d-flex align-start justify-center">
            <v-btn x-large rounded elevation="10" color="indigo darken-1" height="80" min-width="320" class="white--text text-h6" @click="regsterNew()">
                  まずは会員登録（無料）
              </v-btn>
          </v-col>
        </v-row>
      </v-parallax>

      <!-- 商業登記の説明 -->      
      <v-sheet color="grey lighten-5" class="mt-0">
        <v-row class="mt-0" style="height: 10vh;"></v-row>
        <v-container class="container-16 pb-0">
          <v-row no-gutters>
            <v-col cols="12" class="d-flex align-center justify-center text-h5 text-sm-h3 font-weight-bold" >
              <p><span class="font-family-rogo" style="font-size: 1.2em;">登記託</span>は役員変更登記をトータルでサポートするサービスです。</p>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="container-12">
          <v-row class="mb-2">
            <v-col cols="12" class="d-flex align-center justify-center text-h6 text-sm-h5" >
              <p>お客様に代わり役員の変更登記に必要な書類の作成、法務局への登記申請、登記完了後の登記事項証明書の取得に至るまでトータルにサポートします。</p>
            </v-col>
          </v-row>
          <v-row class="mt-8" style="height: 4vh;"></v-row>
          <v-row class="mb-2 my-0">
            <v-col cols="12" class="d-flex align-center justify-center" >
              <!-- <v-banner color="orange darken-1" dark elevation="1" class="text-h6 text-sm-h5 pr-0 pr-sm-3">登記託が選ばれる理由</v-banner> -->
              <v-alert border="bottom" color="orange darken-2" class="white--text text-h6 text-sm-h4 ">登記託が選ばれる理由</v-alert>
            </v-col>
          </v-row>
          <v-row class="mb-2">
            <v-col cols="4" class="d-flex align-center justify-center text-h6 text-sm-h5" >
              <v-img src="@/assets/img/note-pc-request.png" max-height="200" aspect-ratio="1.4" contain></v-img>
            </v-col>
            <v-col cols="4" class="d-flex align-center justify-center text-h6 text-sm-h5" >
              <v-img src="@/assets/img/busines-hand.png" max-height="200" aspect-ratio="1.4" contain></v-img>
            </v-col>
            <v-col cols="4" class="d-flex align-center justify-center text-h6 text-sm-h5" >
              <v-img src="@/assets/img/female-dentaku.png" max-height="200" aspect-ratio="1.4" contain></v-img>
            </v-col>
          </v-row>

          <v-row class="mb-2">
            <v-col cols="4" class="d-flex align-center justify-center text-h6 text-sm-h5" >
              <p>オンラインで簡単お申込み</p>
            </v-col>
            <v-col cols="4" class="d-flex align-center justify-center text-h6 text-sm-h5" >
              <p>司法書士による安心サポート</p>
            </v-col>
            <v-col cols="4" class="d-flex align-center justify-center text-h6 text-sm-h5" >
              <p>低料金で経費削減</p>
            </v-col>
          </v-row>

          <v-row class="mb-0">
            <v-col cols="12" class="d-flex align-center justify-center text-subtitle-1 text-sm-h6 pb-0" style="line-height:180%">
              商業登記は、会社の商号、所在場所、事業目的、役員の氏名等を公示するための制度です。
              <br/> 
              会社は、設立の登記をしてはじめて法人格を取得し、会社として認められることになります。
              <br/> 
              個人の場合、住所が変わったとき、市区町村に転居届を出すように、会社を設立したとき、会社の所在地を移転したとき、役員が変更になったとき、法務局に登記申請をする必要があるのです。
            </v-col>
          </v-row>

          <!-- <v-row class="mb-2">
            <v-col cols="12" class="d-flex align-center justify-center text-h6 text-sm-h5" >
              商業登記は、既にオンラインからの申請が可能になっていますが、電子証明書の取得を含む事前準備の手間、申請書のみならず添付書類の作成についての知識も必要であることから、会社が自ら対応するのは簡単ではありません。 また、登記申請が必要となる機会は、それほど頻繁にあるものでもなく、株式会社の場合、最長で１０年間登記申請をしないケースもあり、過去に対応した担当者が会社にいない、 当時の書類が残っておらず対応の仕方が分からないこともある上、やっとの思いで登記申請をしても、法務局から何度も補正の指示を受けることも珍しくはありません。
              <br/> 
              登記託は、登記申請が必要な会社と、その担当者に代わり、役員変更が発生した場合の変更登記に必要な書類の作成、法務局への登記申請、登記完了後の登記事項証明書の取得に至るまでトータルでサポートするサービスです。
            </v-col>
          </v-row>

          <v-row class="mt-6">
            <v-col cols="12" class="d-flex align-center justify-center text-h6 text-sm-h5" >
              現代のような複雑でスピードが求められる社会において、会社はそれぞれの本業に集中することが重要です。登記託を用い、アウトソースしていただくことで、確実かつ迅速な登記申請が可能となります。登記託は、良質で安定した法的サービスの実現を目指してまいります。 
            </v-col>
          </v-row> -->

          <v-row class="my-0 align-center justify-start ">
            <v-col cols="12" class="d-flex align-center justify-start text-h6 text-sm-h5 pb-0" >
            <v-btn
              text
              x-large
              color="primary"
              class="px-0"
              @click="showDescription = !showDescription"
            >
              {{ showDescription ? '...続きを読む' : '閉じる' }}
            </v-btn>
            </v-col>
          </v-row>
          <v-row v-show="!showDescription" class="mb-2">
            <v-col cols="12" class="d-flex align-center justify-center text-subtitle-1 text-sm-h6" style="line-height:180%">
              商業登記は、既にオンラインからの申請が可能になっていますが、電子証明書の取得を含む事前準備の手間、申請書のみならず添付書類の作成についての知識も必要であることから、会社が自ら対応するのは簡単ではありません。 また、登記申請が必要となる機会は、それほど頻繁にあるものでもなく、株式会社の場合、最長で１０年間登記申請をしないケースもあり、過去に対応した担当者が会社にいない、 当時の書類が残っておらず対応の仕方が分からないこともある上、やっとの思いで登記申請をしても、法務局から何度も補正の指示を受けることも珍しくはありません。
              <br/> 
              登記託は、登記申請が必要な会社と、その担当者に代わり、役員変更が発生した場合の変更登記に必要な書類の作成、法務局への登記申請、登記完了後の登記事項証明書の取得に至るまでトータルでサポートするサービスです。
            </v-col>
          </v-row>

          <v-row v-show="!showDescription" class="mt-6">
            <v-col cols="12" class="d-flex align-center justify-center text-subtitle-1 text-sm-h6" style="line-height:180%">
              現代のような複雑でスピードが求められる社会において、会社はそれぞれの本業に集中することが重要です。登記託を用い、アウトソースしていただくことで、確実かつ迅速な登記申請が可能となります。登記託は、良質で安定した法的サービスの実現を目指してまいります。 
            </v-col>
          </v-row>


        </v-container>
      </v-sheet>

      <v-row class="mt-8" style="height: 2vh;"></v-row>

      <v-container class="container-5">
        <v-row class="mt-8" style="height: 6vh;">
          <v-col cols="12" sm="1" md="1" lg="1" xl="1" ></v-col>
          <v-col cols="12" sm="12" md="12" lg="12" xl="12"  class= "d-flex align-center justify-center">
            <p class="text-h6 text-sm-h5 text-lg-h4 text-xl-h4 under ml-0 mr-0 font-weight-bold " style="max-width: 600px;">こんなことにお困りではないですか？</p>
          </v-col>
        </v-row>
        <!-- 登記託メリット-->
        <v-row >
          <v-col cols="12" sm="1" md="1" lg="1" xl="1" ></v-col>
          <v-col cols="12" sm="10" md="10" lg="10" xl="10" >
            <v-card flat >
              <v-card-text class="py-0 py-sm-0 py-md-0 py-lg-12">
                <v-row>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="d-flex align-end justify-center">
                    <transition name="fade">
                      <div v-show="cardViewFlg4">
                        <v-img src="@/assets/img/to-worry-man.png" width="160px"></v-img>
                      </div>
                    </transition>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="d-flex align-start justify-center" style="font-size: 1.4em">
                    <transition name="fade">
                      <div class="speech-bg-1" style="color: #FB8C00; " v-show="cardViewFlg4">
                        役員変更の登記申請をしたいけど、<br>時間は無いし、何をどうしたらいいのかわからない。<br>
                        どこか信頼できるところに相談したいけど・・・・
                      </div>
                    </transition>
                  </v-col>
                  <v-col cols="12" sm="1" md="1" lg="1" xl="1" ></v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="d-flex align-end justify-center">
                    <transition name="fade">
                      <div v-show="cardViewFlg5">
                        <v-img src="@/assets/img/business-man-headset.png" width="200px"></v-img>
                      </div>
                    </transition>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="d-flex align-start justify-center" style="font-size: 1.4em">
                    <transition name="fade">
                      <div class="speech-bg-1" style="color: #FB8C00; " v-show="cardViewFlg5">
                        株式会社の役員変更は、２週間以内に管轄の法務局に役員変更登記を申請する必要がありますので、オンラインで便利な「登記託」をぜひご利用ください。<br><br>
                        心配事はすべて「登記託」が解決します。<br>面倒な書類作成や登記申請はおまかせください！<br>
                      </div>
                    </transition>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="1" md="1" lg="1" xl="1" ></v-col>
        </v-row>
      </v-container>

      <v-row class="mt-8" style="height: 2vh;"></v-row>

      <v-container class="container-7">
        <v-row class="mb-2">
          <v-col cols="12" class="d-flex align-center justify-center text-h5 text-sm-h4" >
              ～ ご利用開始 ～
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="12" class="d-flex align-center justify-center text-caption text-sm-h5">
            サービスを利用するには会員登録(無料)が必要です。
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="0" lg="1" xl="2"></v-col>
          <v-col cols="12" sm="12" md="6" lg="5" xl="4" class="d-flex align-center justify-center" >
            <v-btn large outlined rounded elevation="10" color="indigo darken-1" min-height="100" class="white--text text-h6" @click="regsterNew()">
              <v-row>
                <v-col cols="3" class="px-0">
                  <v-img src="@/assets/img/shoshinsha_mark-1-p0.svg"  height="80" width="100"></v-img>
                </v-col>
                  <v-col cols="9" class="d-flex align-center justify-center px-0">
                  はじめてご利用になる方
                </v-col>
              </v-row>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="5" xl="4" class="d-flex align-center justify-center">
            <v-btn large outlined rounded elevation="10" color="blue darken-4" min-height="100" class="white--text text-h6" @click="login()">
              <v-row>
                <v-col cols="3" class="px-0">
                  <v-img src="@/assets/img/account.svg"  height="80" width="100"></v-img>
                </v-col>
                <v-col cols="9" class="d-flex align-center justify-center px-0">
                  アカウントをお持ちの方
                </v-col>
              </v-row>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="0" lg="1" xl="2"></v-col>
        </v-row>
      </v-container>

      <v-row class="mt-8" style="height: 4vh;"></v-row>

      <!-- 流れ -->
      <v-sheet color="blue lighten-5">
        <v-row class="mt-8" style="height: 6vh;"></v-row>
          <div style="img-box">
            <v-img src="@/assets/img/handshake.png" class="img-box-right"></v-img>
          </div>
        <!-- <v-container> -->

          <v-container class="container-9">
            <v-row class="mb-12">
              <v-col cols="12" class="d-flex align-center justify-center text-h4 text-sm-h3">
                ご利用の流れ
              </v-col>
            </v-row>

            <v-row class="mx-0 px-0" >
              <v-col cols="12" sm="12" md="12" lg="3" xl="3" class="">
                <v-card shaped elevation="12" class="mx-auto" max-width="380" height="520" color="orange lighten-4" >
                  <v-row>
                    <v-col cols="12" class="d-flex align-center justify-center">
                      <v-avatar color="indigo" size="62">
                        <v-icon dark>mdi-numeric-1-circle</v-icon>
                      </v-avatar>
                    </v-col>
                  </v-row>
                  <v-card-text class="d-flex align-center justify-center text-h5 ">お申込み</v-card-text>
                  <v-card-text class="d-flex align-center justify-center black--text text-subtitle-1 text-md-subtitle-1 text-md-h6 pb-0">
                    会員登録後
                    役員変更や住所変更等のお申込み情報をオンラインで入力していただきます。 
                  </v-card-text>
                  <v-card-text class="pt-0">
                    <v-img src="@/assets/img/note_pc.png" style="opacity: 0.5;" height="200" aspect-ratio="1.4" contain></v-img>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" sm="12" md="12" lg="3" xl="3" class="">
                <v-card shaped elevation="12" class="mx-auto" max-width="380" height="520" color="orange lighten-4">
                  <v-row>
                    <v-col cols="12" class="d-flex align-center justify-center">
                      <v-avatar color="indigo" size="62">
                        <v-icon dark>mdi-numeric-2-circle</v-icon>
                      </v-avatar>
                    </v-col>
                  </v-row>
                  <v-card-text class="d-flex align-center justify-center text-h5">本人確認</v-card-text>
                  <v-card-text class="d-flex align-center justify-center black--text text-subtitle-1 text-md-subtitle-1 text-md-h6 pb-0">
                    ご担当者様のご本人確認をお願いしています。本人確認用の書類や、顔写真をオンラインで提出していただきます。 
                  </v-card-text>
                  <v-card-text class="pt-0">
                    <v-img src="@/assets/img/female-smart-phone.png" style="opacity: 0.5;" height="200" aspect-ratio="1.4" contain></v-img>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" sm="12" md="12" lg="3" xl="3" class="">
                <v-card shaped elevation="12" class="mx-auto" max-width="380" height="520" color="orange lighten-4">
                  <v-row>
                    <v-col cols="12" class="d-flex align-center justify-center">
                      <v-avatar color="indigo" size="62">
                        <v-icon dark>mdi-numeric-3-circle</v-icon>
                      </v-avatar>
                    </v-col>
                  </v-row>
                  <v-card-text class="d-flex align-center justify-center text-h5">書類郵送</v-card-text>
                  <v-card-text class="d-flex align-center justify-center black--text text-subtitle-1 text-md-subtitle-1 text-md-h6 pb-0">
                    当事務所から郵送された申請書類を確認・押印していただき、ご準備頂いた書類と合わせ当事務所へ返送していただきます。 
                  </v-card-text>
                  <v-card-text class="pt-0">
                    <v-img src="@/assets/img/mailbin.png" style="opacity: 0.5;" height="200" aspect-ratio="1.4" contain></v-img>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" sm="12" md="12" lg="3" xl="3" class="">
                <v-card shaped elevation="12" class="mx-auto" max-width="380" height="520" color="orange lighten-4">
                  <v-row>
                    <v-col cols="12" class="d-flex align-center justify-center">
                      <v-avatar color="indigo" size="62">
                        <v-icon dark>mdi-numeric-4-circle</v-icon>
                      </v-avatar>
                    </v-col>
                  </v-row>
                  <v-card-text class="d-flex align-center justify-center text-h5">登記完了</v-card-text>
                  <v-card-text class="d-flex align-center justify-center black--text text-subtitle-1 text-md-subtitle-1 text-md-h6 pb-0">
                    当事務所から申請に必要な書類一式を管轄の法務局へ郵送します。登記完了後、お客様へ登記事項証明書を郵送します(オプション)。 
                  </v-card-text>
                  <v-card-text class="pt-0">
                    <v-img src="@/assets/img/kurakaa.png" style="opacity: 0.5;" height="200" aspect-ratio="1.4" contain></v-img>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-img src="@/assets/img/female-clerk.png" class="img-box-left-down-2"></v-img>
            </v-row>
          </v-container>
        <v-row style="height: 10vh;"></v-row>
      </v-sheet>

      <v-row class="mt-8" style="height: 10vh;"></v-row>

      <!-- 料金 -->
      <v-container class="container-12">
        <v-row class="mb-0" dense>
          <v-col cols="12" class="d-flex align-center justify-center text-h4 text-sm-h3">
              ご利用料金
          </v-col>
        </v-row>
      </v-container>
      <v-container class="container-9">
          <v-sheet >
            <v-row class="mx-0 px-0" >
              <!-- <v-col cols="0" sm="0" md="0" lg="1" xl="1" ></v-col> -->
              <v-col cols="12" sm="12" md="12" lg="4" xl="4" >
                <v-card class="mx-auto" max-width="380">
                  <v-img class="white--text align-end" height="200px" src="@/assets/img/business-man-yatta.jpg" gradient="to top right, rgba(0,0,0,.13), rgba(0,0,0,.23)">
                    <v-card-title class="font-weight-bold white--text text-h4 py-0 d-flex align-center justify-center">役員変更</v-card-title>
                    <v-card-title class="indigo--text text-h6 d-flex align-center justify-center">Officer change</v-card-title>
                  </v-img>
                  <v-divider></v-divider>
                  <v-card-subtitle class="black--text  text-h6 pb-0 d-flex align-center justify-center">
                    10,000円（税抜き）
                  </v-card-subtitle>
                  <v-card-text class="black--text d-flex align-center justify-center" style="height: 60px;">
                    <div>登録免許税は別途必要となります。</div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4" xl="4" class="">
                <v-card class="mx-auto" max-width="380">
                  <v-img class="white--text align-end" height="200px" src="@/assets/img/business-man.jpg" gradient="to top right, rgba(0,0,0,.23), rgba(0,0,0,.33)">
                    <v-card-title class="font-weight-bold white--text text-h5 py-0 d-flex align-center justify-center">代表取締役の住所変更</v-card-title>
                    <v-card-title class="amber--text text-h6 d-flex align-center justify-center">Address change</v-card-title>
                  </v-img>
                  <v-divider></v-divider>
                  <v-card-subtitle class="black--text text-h6 pb-0 d-flex align-center justify-center">
                    10,000円（税抜き）
                  </v-card-subtitle>
                  <v-card-text class="black--text d-flex align-center justify-center" style="height: 60px;">
                    <div>登録免許税は別途必要となります。</div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4" xl="4" class="">
                <v-card class="mx-auto" max-width="380">
                  <v-img class="white--text align-end" height="200px" src="@/assets/img/pepars.jpg" gradient="to top right, rgba(0,0,0,.23), rgba(0,0,0,.33)">
                    <v-card-title class="font-weight-bold white--text text-h5 ont-weight-black py-0 d-flex align-center justify-center">登記事項証明書の郵送</v-card-title>
                    <v-card-title class="indigo--text text-h6 d-flex align-center justify-center">Send by post</v-card-title>
                  </v-img>
                  <v-divider></v-divider>
                  <v-card-subtitle class="black--text text-h6 pb-0 d-flex align-center justify-center">
                    1,000円（税抜き）
                  </v-card-subtitle>
                  <v-card-text class="black--text" style="height: 60px;">
                    <br/>
                  </v-card-text>
                </v-card>
              </v-col>
              <!-- <v-col cols="0" sm="0" md="0" lg="1" xl="1" ></v-col> -->
            </v-row>
        </v-sheet>
      </v-container>

      <v-row class="btm-space-height"></v-row>

      <v-container class="container-12">
        <v-row class="">
          <v-col cols="12" class="text-subtitle-1 text-sm-h5">
            <p class="d-flex align-center justify-center"> 登記託は、役員変更登記に対応しております。</p>
            <p class="d-flex align-center justify-center"> 役員変更以外の登記についても順次対応予定です。</p>
            <p class="d-flex align-center justify-center"> お問い合わせ・ご相談は、問合せページにてお気軽にご相談ください。</p>
          </v-col>
        </v-row>
        <!-- <v-row class="mt-8" style="height: 2vh;"></v-row> -->
        <v-row class="">
          <v-col cols="12" class="d-flex align-center justify-center">
            <v-btn x-large elevation="10" color="blue darken-3" class="white--text" @click="toInquiryScreen()">
              <v-icon >mdi-email-outline</v-icon>
                  &nbsp;お問い合わせ・ご相談
              </v-btn>
            </v-col>
        </v-row>
      </v-container>
      
      <v-row class="mt-8" style="height: 2vh;"></v-row>

      <v-container class="container-7">
        <v-row class="mb-2">
          <v-col cols="12" class="d-flex align-center justify-center text-h5 text-sm-h4" >
              ～ ご利用開始 ～
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="12" class="d-flex align-center justify-center text-caption text-sm-h5">
            サービスを利用するには会員登録(無料)が必要です。
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="0" lg="1" xl="2"></v-col>
          <v-col cols="12" sm="12" md="6" lg="5" xl="4" class="d-flex align-center justify-center" >
            <v-btn large outlined rounded elevation="10" color="blue darken-4" min-height="100" class="white--text text-h6" @click="regsterNew()">
              <v-row>
                <v-col cols="3" class="px-0">
                  <v-img src="@/assets/img/shoshinsha_mark-1-p0.svg"  height="80" width="100"></v-img>
                </v-col>
                  <v-col cols="9" class="d-flex align-center justify-center px-0">
                  はじめてご利用になる方
                </v-col>
              </v-row>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="5" xl="4" class="d-flex align-center justify-center">
            <v-btn large outlined rounded elevation="10" color="blue darken-4" min-height="100" class="white--text text-h6" @click="login()">
              <v-row>
                <v-col cols="3" class="px-0">
                  <v-img src="@/assets/img/account.svg"  height="80" width="100"></v-img>
                </v-col>
                <v-col cols="9" class="d-flex align-center justify-center px-0">
                  アカウントをお持ちの方
                </v-col>
              </v-row>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="0" lg="1" xl="2"></v-col>
        </v-row>
      </v-container>

      <v-row class="mt-8" style="height: 9vh;"></v-row>

      <!-- 問い合わせ -->
      <template v-if="snackbarComputed">
        <v-snackbar v-model="snackbar" :timeout="snkTimeout" :centered='true' :right='true' :elevation='24' color="blue lighten-4" :vertical='true'>
          <v-card color="transparent" flat>
            <v-card-title class="font-weight-bold black--text ">まずは無料会員登録</v-card-title>
            <v-card-subtitle class="black--text pb-0">サービスを利用するには会員登録(無料)が必要です</v-card-subtitle>
            <v-card-text class="black--text">
              <v-row >
                <v-col cols="12" class="pb-0">
                  <v-btn rounded large elevation="10" color="indigo darken-1" class="white--text" @click="regsterNew()">
                    会員登録(無料)
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-title class="font-weight-bold black--text ">お問い合わせはこちら</v-card-title>
            <v-card-subtitle class="black--text pb-0">お気軽にご相談ください。</v-card-subtitle>
            <v-card-text class="black--text">
              <!-- <v-row style="height: 10px;"></v-row> -->
              <v-row >
                <v-col cols="12" class="">
                  <div style="info-box">
                  <v-btn large elevation="10" color="blue darken-3" @click="toInquiryScreen()">
                    <v-icon >mdi-email-outline</v-icon>
                    &nbsp;お問い合わせ・ご相談
                  </v-btn>
                  <v-img src="@/assets/img/tqsman-big.png" class="info-box-right"></v-img>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <div class="info-box-right-closs">
            <v-btn fab small color="primary" @click="closeSnackbar()">
              <v-icon dark>mdi-window-close</v-icon>
            </v-btn>
          </div>
        </v-snackbar>
      </template>

        <v-fab-transition>
          <v-btn
            color="indigo"
            fab
            dark
            large
            absolute
            right
            style="bottom:20px; position:fixed;"
            @click="$vuetify.goTo(0)"  
            v-show="btnTopMoveActive"
          >
            <v-icon>mdi-navigation</v-icon>
          </v-btn>
        </v-fab-transition>

    </v-main>
    <!-- フッター -->
    <!-- 利用規約 プライバシーポリシー 特定商取引法に基づく表記 -->
    <!-- <v-row class="mt-4" style="height: 8vh;"></v-row> -->
    <comFooterAnyone :contactUsDspFlg="!snackbarComputed" :moveTopDspPos="moveTopButtonPos" :propSrcScreenId="screenId"></comFooterAnyone>
  </div>
</template>

<script>
// import Utils from "../common/utils";
export default {
  name: "HomePage",
  data() {
    return {
      screenTitle: "",
      screenId: "PSS100",
      kbnTypHelp: "100",
      KbnCdQA: "0",
      KbnCdTejyun: "1",
      KbnCdPlan: "2",

      windowWidth: 0,
      snackbar: false,
      snkTimeout: 0,
      moveTopButtonPos: 'right',

      cardViewFlg: false,
      cardViewFlg0: false,
      cardViewFlg1: false,
      cardViewFlg2: false,
      cardViewFlg3: false,
      cardViewFlg4: false,
      cardViewFlg5: false,

      info: [],
      token: "",

      btnTopMoveActive: false,
      scroll: 0,
      appBarTransparent: true,

      showDescription: true,

      snackbarComputed: true,
      snackbarClosed: false,

    };
  },
  computed:  {
    // ...mapGetters('authcUser', ['getAccessToken', 'getLoggedUserInfo'])
    tileimgsrc: function() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        return require("@/assets/img/aozora-mrk2.png");
        // return require("@/assets/img/aozora-mrk.png");
      } else {
        return require("@/assets/img/aozora-logo.svg");
      }
    },
  },
  watch: {

  },
  mounted() {
    window.addEventListener('scroll', this.scrollWindow);
    // window.addEventListener('resize', this.onResize);
    window.addEventListener('scroll', this.onScroll);
    this.animatSubtitleCard();

    let bp =this.$vuetify.breakpoint.name;
    if (bp == 'xs' ) {
      this.snackbarComputed = false;
    }
  },
  created() {
    this.initialize();
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.onResize);
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    closeSnackbar: function() {
      this.snackbar = false;
      this.snackbarClosed = true;
    },
    initialize: function() {
      this.LandingPageFlg = false;
      let pwdresetkey = this.$route.query.pwdresetkey;
      if (pwdresetkey != undefined) {
        this.$router.push(this.$router.resolve({ name: 'MBC210', params: {onetimeurl: pwdresetkey} }).href);
        return;
      }
      let key = this.$route.query.vfappkey;
      let no = this.$route.query.no;
      let id = this.$route.query.id;
      if (key != undefined && no != undefined && id != undefined) {
        this.$router.push(this.$router.resolve({ name: 'APA100', params: {accesskey: key, receiptno:no, systemid: id} }).href);
        return;
      }

      let screenId = this.$route.query.screenId;
      if (screenId == 'mta100') {
        this.$router.push(this.$router.resolve({ name: "MTA100" }).href);
        return;
      } else if (screenId == 'vfa100') {
        this.$router.push(this.$router.resolve({ name: "VFA100" }).href);
        return;
      }
      
      if (screenId == 'pss400') { 
        this.$router.push(this.$router.resolve({ name: "PSS400", params: {srcScreenId: 'PSS100'} }).href);
        return;
      }
      if (screenId == 'mbc100') {
        this.$router.push(this.$router.resolve({ name: "MBC100" }).href);
        return;
      }
    },
    scrollWindow() {
      const showBtnPoint = 200;
      this.scroll = window.scrollY;
      if (showBtnPoint <= this.scroll) {
        this.btnTopMoveActive = true;
      } else {
        this.btnTopMoveActive = false;
      }
      const changeBarPoint = 860;
      if (changeBarPoint >= this.scroll) {
        this.appBarTransparent = true;
      } else {
        this.appBarTransparent = false;
      }
      const showSnackbarPoint = 600;
      if (!this.snackbarClosed) {
        if (this.snackbarComputed) {
          if (showSnackbarPoint <= this.scroll) {
            this.snackbar = true;
          } else {
            this.snackbar = false;
          }
        }
      }
    },
    /**
     * card表示(登記託サブタイトル)
     */
    animatSubtitleCard() {
      this.cardViewFlg = true;
    },
      /**
     * card表示(商業登記とは)
     */
    animatToukiCard() {
      this.cardViewFlg0 = true;
    },
      /**
     * card表示(お困り事)
     */
    animatOkomariCard() {
      this.cardViewFlg4 = true;
      this.cardViewFlg5 = true;
    },
    /**
     * card表示(ヘルプ)
     */
    animatHelpCard() {
      this.cardViewFlg1 = true;
      this.cardViewFlg2 = true;
      this.cardViewFlg3 = true;
      this.cardViewFlg4 = true;
    },
    /**
     * 問い合わせ登録画面遷移
     */
    toInquiryScreen: function() {
      this.$router.push(this.$router.resolve({ name: 'PSS400', params: {srcScreenId: this.screenId} }).href)
      // let routeData = this.$router.resolve({name: "PSS400"});
      // window.open(routeData.href, "_blank", 'noreferrer');
    },
    /**
     * ログイン画面遷移
     */
    login: function() {
      this.$router.push(this.$router.resolve({ name: "MBA100" }).href);
    },
    /**
     * アカウント登録画面遷移
     */
    regsterNew: function() {
      this.$router.push(this.$router.resolve({ name: "MBC100", params: {srcScreenId: this.screenId} }).href);
      // // 別タブ表示
      // let routeData = this.$router.resolve({name: "MBC100"});
      // window.open(routeData.href, "_blank", 'noreferrer');
    },
    // /**
    //  * ヘルプ画面へ遷移
    //  */
    // toHelpScreen: function(kbnCdVal) {
    //   // 引数チェックs
    //   if (Utils.isNullOrEmptyOrUunDef(kbnCdVal)) {
    //     return;
    //   }
    //   // 別タブ表示
    //   let routeData = this.$router.resolve({
    //     name: "PSS300",
    //     params: { kbnTyp: this.kbnTypHelp, KbnCd: kbnCdVal },
    //   });
    //   window.open(routeData.href, "_blank", 'noreferrer');
    // },
    /**
     * ページ内リンク
     */
    scrollToAnchorPoint: function(refPoint) {
      let el = this.$refs[refPoint];
      el.scrollIntoView({ behavior: 'smooth'});
    },
    /**
     * windowリサイズイベント
     */
    onResize: function() {
      // let bp =this.$vuetify.breakpoint.name;
      // if (bp == 'xs' ) {
      //   this.snackbar = false;
      // } else {
      //   this.snackbar = true;
      // }

      // this.windowWidth = window.innerWidth;
      // if (this.windowWidth <= 750) {
      //   this.snackbar = false;
      // } else {
      //   this.snackbar = true;
      // }
    },
    /**
     * スクロールイベント
     */
    onScroll: function() {
      // if (!this.snackbar) {
      //   return;
      // }
      if (window.scrollY > 10 && window.scrollY < 400) {
        this.animatToukiCard();
      } else if (window.scrollY > 400 && window.scrollY < 800) {
        this.animatOkomariCard();
      } else if (window.scrollY > 800) {
        this.animatHelpCard();
      }
      // this.onResize();
    },
    scrollTop: function() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  },
};
</script>
<style scoped>
html, body, #wrap {
    height: 100%;
}
#wrap {
    position: relative;
}
#svg-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
}
.font-family-rogo {
  position: relative;
  font-family: "HGP行書体", 'ヒラギノ明朝 Pro W3', 'Hiragino Mincho Pro', '游明朝','Yu Mincho', '游明朝体', 'YuMincho','ＭＳ Ｐ明朝', 'MS PMincho', serif;
  font-weight: bold;
  /*font-size: 3.3em;*/
}
.font-family-comment {
  position: relative;
  font-family: 'メイリオ', 'Meiryo', '游ゴシック', 'Yu Gothic', 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
  font-weight: bold;
  /*font-size: 3.3em;*/
}
.text-kanji-logo {
  font-size: 8rem !important;
  font-weight: 300;
  line-height: 8rem;
  letter-spacing: -0.015625em !important;
  animation-name: fadein;
  animation-duration: 18s;
  /* animation-iteration-count: infinite; */
}
.subtitleEn {
  font-size: 0.8em;
}
@keyframes fadein {
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.info-box {
  position: relative;
  height: auto;
  margin: 0 auto;
}
.info-box-right {
  position: absolute; 
  top: 90%;
  right: -10px;
  transform: translateY(-80%);
  width: 100px; 
  height: auto; 
}
.info-box-right-closs {
  position: absolute; 
  top: 100%;
  right: 295px;
  transform: translateY(-80%);
  width: 100px; 
  height: auto; 
}
.info-box-keyframe {
  animation: loop 50s -25s linear infinite;
  animation-name: anim_s;
  transform: rotate(30deg);
  animation-duration: 5s;
}
.btm-space-height {
  height: 0;
}
@keyframes anim_s {
  50% {
      transform: rotate(-30deg);
  }
  100% {
      transform: rotate(30deg);
  }
}

.img-box {
  position: relative;
  height: auto;
  margin: 0 auto;
}
.img-box-right {
  position: absolute; 
  top: 72%;
  right: 80px;
  transform: translateY(-420%);
  width: 200px; 
  height: auto; 
}
.img-box-right-down {
  position: absolute; 
  top: 92%;
  right: 80px;
  transform: translateY(10%);
  width: 130px; 
  height: auto; 
}
.img-box-left {
  position: absolute; 
  top: 90%;
  left: 80px;
  transform: translateY(-320%);
  width: 200px; 
  height: auto; 
}
.img-box-left-down {
  position: absolute; 
  top: 90%;
  left: 120px;
  transform: translateY(-90%);
  width: 180px; 
  height: auto; 
}
.img-box-left-down-2 {
  position: absolute; 
  top: 80%;
  left: 60px;
  transform: translateY(30%);
  width: 130px; 
  height: auto; 
}
/* 吹き出し */
.speech-bg-1 {
  position: relative;
  display: inline-block;
  padding: 20px 20px;
  min-width: 100%;
  max-width: 100%;
  color: #555;
  font-size: 16px;
  background: #FFFDE7;
  border: solid 1px #ffc000;
  border-radius: 15px;
  font-size: 1.0em;
}
.speech-bg-1:before {
  content: "";
  position: absolute;
  top: 35%;
  left: -32px;
  margin-left: 0px;
  border: 12px solid transparent;
  border-right: 20px solid #ffc000;
}
.speech-bg-1:after {
  content: "";
  position: absolute;
  top: 35%;
  left: -31px;
  margin-left: 0px;
  border: 12px solid transparent;
  border-right: 22px solid #ffe699;
}
.speech-bg-1-width {
  max-width: 42%;
}

.under {
  background: linear-gradient(transparent 40%, #ff99ab 70%);
}

.fade-enter-active, .fade-leave-active {
  will-change: opacity;
  transition: opacity 3025ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.fade-enter, .fade-leave-to {
  opacity: 0
}

.top-enter-active, .top-leave-active {
  transform: translate(0px, 0px); 
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.top-enter, .top-leave-to {
  transform: translateY(-100vh) translateY(0px);
}

.top-left-enter-active, .top-left-leave-active {
  transform: translate(0px, 0px); 
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.top-left-enter, .top-left-leave-to {
  transform: translateY(-100vh) translateX(-100vh);
}

.top-right-enter-active, .top-right-leave-active {
  transform: translate(0px, 0px); 
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.top-right-enter, .top-right-leave-to {
  transform: translateY(-100vh) translateX(100vh);
}

.bottom-enter-active, .bottom-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.bottom-enter, .bottom-leave-to {
  transform: translateY(100vh) translateY(0px);
}

.bottom-left-enter-active, .bottom-left-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.bottom-left-enter, .bottom-left-leave-to {
  transform: translateY(100vh) translateX(-100vh);
}

.bottom-right-enter-active, .bottom-right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.bottom-right-enter, .bottom-right-leave-to {
  transform: translateY(100vh) translateX(100vh);
}

.left-enter-active, .left-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.left-enter, .left-leave-to {
  transform: translateX(-100vw) translateX(0px);
}

.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}

.Page-Btn{
  position: fixed;
  right: 14px;
  bottom: 14px;
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 50%;
  background: #5bc8ac;
}
.Page-Btn-Icon{
  color: #fff;
  font-size: 16px;
}
.v-parallax__image {
  transform: none !important;
  width: 100% !important;
}
@media screen and (max-width: 750px) {

  .text-kanji-logo {
    font-size: 6rem !important;
    font-weight: 300;
    line-height: 8rem;
    letter-spacing: -0.015625em !important;
  }
  .speech-bg-1-width {
    max-width: 100%;
  }
  .img-box-right {
    width: 0;
    height: 0;
  }
  .img-box-left-down {
    position: absolute; 
    top: 90%;
    left: 240px;
    transform: translateY(-60%);
    width: 180px; 
    height: auto; 
  }
  .img-box-left-down-2 {
    width: 0;
    height: 0;
  }
  /* .img-box-left-down-2 {
    position: absolute; 
    top: 74%;
    left: 60px;
    transform: translateY(30%);
    width: 130px; 
    height: auto; 
  } */
  
  .subtitleEn {
    font-size: 1.2em;
    /* color: white; */
  }
  .btm-space-height {
    height: 20vh;
  }
}
</style>